import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '@openedx/paragon';

export const PaymentFAQsLink = () => (
  <Hyperlink destination={process.env.NEXT_PUBLIC_EDX_PAYMENT_FAQS_URL!}>
    <FormattedMessage
      id="checkout.error.payment.faqs.link"
      defaultMessage="Payments FAQ"
      description="The support link as in '{Payments FAQ}'"
    />
  </Hyperlink>
);
